import React, { forwardRef } from 'react';

export const Ellipses = forwardRef((props, ref) => (
  <svg
    fill="none"
    height="24"
    ref={ref}
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="4" cy="12" fill="black" r="2" />
    <circle cx="12" cy="12" fill="black" r="2" />
    <circle cx="20" cy="12" fill="black" r="2" />
  </svg>
));
